(() => {
  const root = document.querySelector('[data-bek-withdrawal]');
  if (!root) return;
  const endpoint = root.dataset.endpoint || '/apps/bek-order/withdrawal';
  const form = root.querySelector('[data-withdrawal-form]');
  const step1 = root.querySelector('[data-withdrawal-step="1"]');
  const step2 = root.querySelector('[data-withdrawal-step="2"]');
  const next = root.querySelector('[data-withdrawal-next]');
  const back = root.querySelector('[data-withdrawal-back]');
  const submit = root.querySelector('[data-withdrawal-submit]');
  const error = root.querySelector('[data-withdrawal-error]');
  const success = root.querySelector('[data-withdrawal-success]');
  const card = root.querySelector('[data-withdrawal-card]');

  const field = (name) => form?.elements.namedItem(name);
  const showError = (message='') => {
    if (!error) return;
    error.textContent = message;
    error.classList.toggle('is-visible', Boolean(message));
  };
  const value = (name) => String(field(name)?.value || '').trim();
  const validStep1 = () => {
    if (value('name').length < 2) return 'Bitte geben Sie Ihren Namen ein.';
    if (!field('email')?.validity.valid || !value('email')) return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    if (!value('orderNumber')) return 'Bitte geben Sie Ihre Bestell- oder Vertragsnummer ein.';
    if (!field('privacy')?.checked) return 'Bitte bestätigen Sie die Datenschutzhinweise.';
    return '';
  };
  const fillSummary = () => {
    const map = { name:'summaryName', email:'summaryEmail', orderNumber:'summaryOrder', contractPart:'summaryPart', message:'summaryMessage' };
    Object.entries(map).forEach(([source,target]) => {
      const el = root.querySelector(`[data-${target.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}]`);
      if (el) el.textContent = value(source) || (source === 'contractPart' ? 'Gesamter Vertrag / gesamte Bestellung' : '—');
    });
  };
  const showStep = (n) => {
    step1?.classList.toggle('is-active', n === 1);
    step2?.classList.toggle('is-active', n === 2);
    showError('');
    root.scrollIntoView({ behavior:'smooth', block:'start' });
  };
  next?.addEventListener('click', () => {
    const msg = validStep1();
    if (msg) return showError(msg);
    fillSummary(); showStep(2);
  });
  back?.addEventListener('click', () => showStep(1));

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const msg = validStep1();
    if (msg) return showError(msg);
    if (!field('confirmed')?.checked) return showError('Bitte bestätigen Sie, dass Sie den Widerruf jetzt absenden möchten.');
    submit.disabled = true;
    const old = submit.textContent;
    submit.textContent = 'Widerruf wird übermittelt …';
    showError('');
    try {
      const payload = {
        name:value('name'), email:value('email'), orderNumber:value('orderNumber'),
        contractPart:value('contractPart'), message:value('message'), website:value('website'),
        privacy:Boolean(field('privacy')?.checked), confirmed:Boolean(field('confirmed')?.checked)
      };
      const response = await fetch(endpoint, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify(payload) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) throw new Error(data.message || 'Der Widerruf konnte gerade nicht übermittelt werden.');
      card.style.display = 'none';
      success?.classList.add('is-visible');
      const id = root.querySelector('[data-withdrawal-success-id]'); if (id) id.textContent = data.id || '';
      const when = root.querySelector('[data-withdrawal-success-time]'); if (when && data.receivedAt) when.textContent = new Date(data.receivedAt).toLocaleString('de-DE');
      success?.scrollIntoView({ behavior:'smooth', block:'center' });
    } catch (e) { showError(e?.message || 'Der Widerruf konnte gerade nicht übermittelt werden.'); }
    finally { submit.disabled = false; submit.textContent = old; }
  });
})();
